<template>
  <div id="appHomeVueComponent">
    <HeaderApp />
    <div class="appFontBlack">
      <div class="AppHomeTitle">
        <br>
        <h2>Bienvenue Sonia</h2>
        <br>
      </div>
      <div class="appHomeLine">
        <button @click.prevent="choiceCollection()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Collection.svg" alt="Logo encaissement"> Encaissement</button>
        <button @click.prevent="choicePublication()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Web.svg" alt="Logo internet"> Articles Web</button>
      </div>
      <div class="appHomeLine">
        <button @click.prevent="choiceClients()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Client.svg" alt="Logo client"> Clients</button>
        <button @click.prevent="choiceProducts()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Products.svg" alt="Logo produits"> Produits</button>
      </div>
      <div class="appHomeLine">
        <button @click.prevent="choiceTarifs()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Tarifs.svg" alt="Logo tarifs"> Tarifs</button>
        <button @click.prevent="choiceSpendings()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Spending.svg" alt="Logo dépenses"> Dépenses</button>
      </div>
      <div class="appHomeLine">
        <button @click.prevent="choiceStatistics()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Statistics.svg" alt="Logo statistiques"> Statistiques</button>
        <button @click.prevent="choiceSettings()" type="submit" class="appButtonModel1"><img class="appHomeLogo"
            src="../../assets/Icon-Settings.svg" alt="Logo paramètres"> Paramètres</button>
      </div>
      <br>
      <FooterApp />
      <br>
    </div>
  </div>
</template>

<script>
import HeaderApp from '../Application/HeaderApp.vue'
import FooterApp from '../Application/FooterApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp, FooterApp
  },
  name: 'home',
  data () {
    return {
    }
  },
  methods: {
    choiceCollection () {
      this.$router.push('/App/Collection')
    },
    choicePublication () {
      this.$router.push('/App/Publications')
    },
    choiceClients () {
      this.$router.push('/App/Clients')
    },
    choiceProducts () {
      this.$router.push('/App/Products')
    },
    choiceTarifs () {
      this.$router.push('/App/Tarifs')
    },
    choiceSpendings () {
      this.$router.push('/App/Spendings')
    },
    choiceStatistics () {
      this.$router.push('/App/Statistics')
    },
    choiceSettings () {
      this.$router.push('/App/Settings')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppHome.vue